import * as React from "react";
import { Spin } from "antd";
export function Loading({ message }) {
    return (React.createElement("div", { style: {
            height: "100%",
            width: "100%",
            padding: 50,
            textAlign: "center",
        } },
        React.createElement(Spin, { style: {
                height: "100%",
                width: "100%",
                padding: 50,
                textAlign: "center",
            } }),
        message && React.createElement("div", { style: { paddingTop: 20 } }, message)));
}
//# sourceMappingURL=Loading.js.map